import { render, staticRenderFns } from "./CreateEditProduct.vue?vue&type=template&id=08281c44"
import script from "./CreateEditProduct.vue?vue&type=script&lang=js"
export * from "./CreateEditProduct.vue?vue&type=script&lang=js"
import style0 from "./CreateEditProduct.vue?vue&type=style&index=0&id=08281c44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports